import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconStop: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="4" y="4" width="8" height="8" fill="currentColor" />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="4" y="4" width="12" height="12" fill="currentColor" />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="5" y="5" width="14" height="14" fill="currentColor" />
                </svg>
            );
    }
};
